
import striptags from 'striptags'
import { validateInt } from '@/helpers'

export default class PostService
{
	constructor(http) {
        this.http = http
        this.baseFilter = [
            // { property: "areas__parent__slug", value: "intranet", stage: 1000 }
        ]
    }

    getLastVersion(key)
    { return JSON.parse(localStorage.getItem(key)) }

    setLastVersion(key, data)
    { localStorage.setItem(key, JSON.stringify(data)) }

    async get({ filter = [], start = 0, limit = 5, page = 1 } = {})
    {
        const endpoint = '/posts'
        const filters = JSON.stringify([ ...this.baseFilter, ...filter ])
        const params = { filters, start, limit, page, status: 'published' }

        const response = await this.http.get(endpoint, { params })
        // const key = `${endpoint}${JSON.stringify(params)}`
        // if( response.status === 304 )
        //     response.data = {...response.data, ...this.getLastVersion(key)}
        // else if( response.status === 200 )
        // {
        //     const count = response.data.count
        //     const collection = response.data.collection
        //     this.setLastVersion(key, {count, collection})
        // }

        return response
    }

	async getLastNews()
    {
        const filter = [{ property: "areas__slug", value: "destaque", stage: 1001 }]
        const { data } = await this.get({ filter, limit: 5 })

        return data.collection
    }

    async institutionalProjects()
    {
        const filter = [{ property: "areas__slug", value: "institucionais", stage: 1001 }]
        const { data } = await this.get({ filter, limit: 24 })

        return data.collection
    }

    async tip()
    {

        const filter = [{ property: "areas__slug", value: "fica-a-dica", stage: 1001 }]
        const { data } = await this.get({ filter, limit: 3 })

        data.collection = data.collection.map(item => {
            const itemText = item.text && striptags(item.text).length > 0 ? striptags(item.text) : ''
            const abstract = item.lead && striptags(item.lead).length > 0 ? striptags(item.lead) : itemText
            return {
                ...item,
                abstract: abstract.slice(0, 200),
            }
        })

        return data.collection
    }

    async generalBoard()
    {
        const filter = [{ property: "areas__slug", value: "diretoria-geral", stage: 1001 }]
        const { data } = await this.get({ filter, limit: 4 })

        data.collection = data.collection.map(item => {
            const itemText = item.text && striptags(item.text).length > 0 ? striptags(item.text) : ''
            const abstract = item.lead && striptags(item.lead).length > 0 ? striptags(item.lead) : itemText
            return {
                ...item,
                abstract: abstract.slice(0, 200),
            }
        })

        return data.collection
    }

    async express()
    {
        const filter = [{ property: "areas__slug", value: "expresso-mp", stage: 1001 }]
        const { data } = await this.get({ filter, limit: 3 })

        return data.collection
    }

    async search(terms, page)
    {
        const filter = [{ property: "title__icontains", value: terms, stage: 1001 }]
        let params = { filter, limit: 25 }

        page = parseInt(page)
        if(!isNaN(page))
            params.page = page

        const { data } = await this.get(params)

        return {
            count: data.count,
            collection: data.collection.map( item => {
                const itemText = item.text && striptags(item.text).length > 0 ? striptags(item.text) : ''
                const abstract = item.lead && striptags(item.lead).length > 0 ? striptags(item.lead) : itemText
                return {
                    ...item,
                    abstract: abstract.slice(0, 200)
                }
            })
        }
    }

    async byArea(area, { page = 1, start = 0, limit = 25} = {})
    {
        if(area)
        {
            page = validateInt(page, 1)
            start = validateInt(start, 1)
            limit = validateInt(limit, 25)

            const property = isNaN(parseInt(area)) ? "areas__slug" : "areas"
            const filter = [{ property, value: area, stage: 1001 }]
            const params = { filter, page, start, limit }

            const { data } = await this.get(params)

            return {
                ... data,
                collection: data.collection.map(item => {
                    const itemText = item.text && striptags(item.text).length > 0 ? striptags(item.text) : ''
                    const abstract = item.lead && striptags(item.lead).length > 0 ? striptags(item.lead) : itemText
                    return {
                        ...item,
                        abstract: abstract.slice(0, 200)
                    }
                })
            }
        }
        return {}
    }

    async getIndexPage(area, { page = 1, start = 0, limit = 25 } = {}) {
        if (area) {
            page = validateInt(page, 1)
            start = validateInt(start, 1)
            limit = validateInt(limit, 25)

            const property = isNaN(parseInt(area)) ? "areas__slug" : "areas"
            const filter = [
                { property, value: area, stage: 1001 },
                { property: "is_index", value: true, stage: 1002}
            ]
            const params = { filter, page, start, limit }

            const { data } = await this.get(params)

            return {
                ...data,
                collection: data.collection.map(item => {
                    const itemText = item.text && striptags(item.text).length > 0 ? striptags(item.text) : ''
                    const abstract = item.lead && striptags(item.lead).length > 0 ? striptags(item.lead) : itemText
                    return {
                        ...item,
                        abstract: abstract.slice(0, 200)
                    }
                })
            }
        }
        return {}
    }

    async getOne(pk)
    {
        const endpoint = `/post/${pk}`
        const { data } = await this.http.get(endpoint)

        if(!data.success)
            throw data

        return data.collection.pop()
    }

    async videos({ page = 1, start = 0, limit = 3} = {})
    {
        const { collection } = await this.byArea('videos', { page, start, limit })
        return collection
    }

}